<template>
  <el-dialog
    :title="$t('addReportCustom.addReport')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="closeDialog"
  >
    <el-form
      ref="form"
      :model="addReportCustomInfo"
      label-width="120px"
      label-position="left"
    >
      <el-form-item
        :label="$t('addReportCustom.reportGroup')"
        prop="groupId"
        :rules="[
          { required: true, message: $t('addReportCustom.groupRequired'), trigger: 'blur' },
          { max: 30, message: $t('addReportCustom.groupMaxLength'), trigger: 'blur' }
        ]"
      >
        <el-select
          v-model="addReportCustomInfo.groupId"
          style="width: 100%"
          :placeholder="$t('addReportCustom.selectGroup')"
        >
          <el-option
            v-for="(item, index) in addReportCustomInfo.reportCustomGroups"
            :key="index"
            :label="item.name"
            :value="item.groupId"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        :label="$t('addReportCustom.title')"
        prop="title"
        :rules="[
          { required: true, message: $t('addReportCustom.titleRequired'), trigger: 'blur' },
          { max: 64, message: $t('addReportCustom.titleMaxLength'), trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="addReportCustomInfo.title"
          :placeholder="$t('addReportCustom.inputTitle')"
        />
      </el-form-item>

      <el-form-item
        :label="$t('addReportCustom.sort')"
        prop="seq"
        :rules="[
          { required: true, message: $t('addReportCustom.sortRequired'), trigger: 'blur' },
          { max: 11, message: $t('addReportCustom.sortMaxLength'), trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="addReportCustomInfo.seq"
          :placeholder="$t('addReportCustom.inputSort')"
        />
      </el-form-item>

      <el-form-item
        :label="$t('addReportCustom.description')"
        prop="remark"
        :rules="[
          { max: 512, message: $t('addReportCustom.descriptionMaxLength'), trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="addReportCustomInfo.remark"
          type="textarea"
          :placeholder="$t('addReportCustom.inputDescription')"
          :rows="3"
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveReportCustomInfo">
        <i class="el-icon-check"></i>
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveReportCustom, listReportCustomGroups } from '@/api/dev/reportCustomApi'

export default {
  name: 'AddReportCustom',
  data() {
    return {
      dialogVisible: false,
      addReportCustomInfo: {
        groupId: '',
        title: '',
        seq: '',
        remark: '',
        reportCustomGroups: []
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._listAddReportCustomGroups()
    },
    closeDialog() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.addReportCustomInfo = {
        groupId: '',
        title: '',
        seq: '',
        remark: '',
        reportCustomGroups: []
      }
    },
    async saveReportCustomInfo() {
      try {
        await this.$refs.form.validate()
        const res = await saveReportCustom(this.addReportCustomInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('addReportCustom.addSuccess'))
          this.closeDialog()
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async _listAddReportCustomGroups() {
      try {
        const res = await listReportCustomGroups({ page: 1, row: 50 })
        this.addReportCustomInfo.reportCustomGroups = res.data
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>